module.exports = __webpack_public_path__ + "images/null-lists.611ef4a062325093d38a484d25501b5b.png";